import _ from 'lodash';
import reduceReducers from 'reduce-reducers';
import handleChange from './handleChange';

export default function handleChanges(handlers) {
  const reducers = _.keys(handlers).map(pattern => {
    return handleChange(pattern, handlers[pattern]);
  });
  return reduceReducers(...reducers);
}
